import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import Logo from '@/assets/svgs/logo.svg';
import { GLOBAL_LAYOUT_ASIDE_CLASS } from '@/components/template/GlobalLayout/constants';

import { ClientSideBanner } from './LayoutAsideClientComponents';

const LayoutAsideSection = () => {
  return (
    <aside className={GLOBAL_LAYOUT_ASIDE_CLASS}>
      <section className="flex w-fit flex-col items-start max-[1030px]:h-full max-[1030px]:justify-around">
        <section className="flex w-fit flex-col items-start">
          <Logo className="mb-[2.2187rem] h-[2.895625rem] w-140" />
          <p className="mb-[1.8237rem] font-600 text-Gray-900 typo-h4">
            내게 맞는 정책
            <br className="hidden max-[1030px]:inline" /> 웰로에서 찾아요!
          </p>
          <ClientSideBanner
            className={cn(
              'relative mb-[3.3637rem] h-170 w-[30rem] overflow-hidden rounded-medium p-0 active:filter-none',
              'max-[1030px]:hidden',
            )}
          />
        </section>
        <section className="flex w-full items-end justify-between max-[1030px]:flex-col max-[1030px]:items-start max-[1030px]:gap-36">
          <section className="flex flex-col gap-10 max-[1030px]:gap-20">
            <CustomLink
              href="https://www.wello.info/"
              rel="noreferrer noopener"
              target="_blank"
            >
              <div className="flex items-center gap-10 text-[1.125rem] font-600 leading-[150%] max-[1030px]:items-end">
                서비스가
                <br className="hidden max-[1030px]:inline" /> 더 궁금한가요?
                <SvgChevronright className="inline-block size-20 max-[1030px]:mb-[0.21875rem]" />
              </div>
            </CustomLink>
            <CustomLink
              href="https://cdn.welfarehello.com/public_download/%E1%84%8B%E1%85%B0%E1%86%AF%E1%84%85%E1%85%A9+%E1%84%89%E1%85%A5%E1%84%87%E1%85%B5%E1%84%89%E1%85%B3+%E1%84%89%E1%85%A9%E1%84%80%E1%85%A2%E1%84%89%E1%85%A5.pdf"
              rel="noreferrer noopener"
              target="_blank"
            >
              <div className="flex items-center gap-10 text-[1.125rem] font-600 leading-[150%] max-[1030px]:items-end">
                5,200만 국민에게
                <br className="hidden max-[1030px]:inline" /> 정책을 알리고 싶다면?
                <SvgChevronright className="inline-block size-20 max-[1030px]:mb-[0.21875rem]" />
              </div>
            </CustomLink>
          </section>
        </section>
      </section>
    </aside>
  );
};

export default LayoutAsideSection;
